type InfoActionType =
  | { type: '[INFO] - TITLE'; payload: string };

export const infoReducer = (state: any, { type, payload }: InfoActionType) => {
  if (type === '[INFO] - TITLE') return { ...state, title: payload };

  return state;
};
